import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const validatePhoneForE164 = (phone: string): boolean => {
  const regEx = /^[1-9][0-9]{9,14}$/;
  return regEx.test(phone);
};

export function formatFileSize(bytes: number): string {
  const sizes: string[] = ["Bytes", "KB", "MB", "GB", "TB"];
  if (bytes === 0) return "0 Byte";
  const i: number = Math.floor(Math.log(bytes) / Math.log(1024));
  return Math.round(bytes / Math.pow(1024, i)) + " " + sizes[i];
}

export function formatName(name: string): string {
  if (!name) return "";
  const fileParts = name.split(".");
  const fileExtension = fileParts[fileParts.length - 1];
  return fileExtension;
}
